/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";
import TopicComponent from "./TopicComponent";

const CollapsibleFAQs = ({
  activeLanguage,
  handlerSetComponents,
  components,
  languages,
  id,
  reusableComponent,
  reusableComponentSlugname,
  slider
}) => {
  const initialState = {
    type: "LineupContainerSimple",
    title: {
      es: "",
      en: "",
      ca: "",
      pt: ""
    },
    lowercase: true,
    isFaqs: true,
    params: []
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isLowerCase, setLowerCase] = useState(true);

  const inputHandler = e => {
    const { value, name, lang } = e.target;

    const { component } = components[index];

    const comp = {
      ...component,
      [name]: {
        ...component[name],
        [lang.toLowerCase()]: value
      }
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp
    };

    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    if (index >= 0 && components.length) {
      const { component } = components[index];

      const comp = {
        ...component,
        lowercase: isLowerCase
      };
      console.log("comp", comp);
      setState(comp);

      const componentObj = {
        id,
        component: comp
      };

      handlerSetComponents(componentObj, index);
    }
  }, [isLowerCase]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component)
        handlerSetComponents(
          { component: { key: reusableComponentSlugname } },
          componentIndex
        );
    } else {
      setIndex(componentIndex);
      if (component) {
        component.lowercase ? setLowerCase(true) : setLowerCase(false);
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const addTopic = () => {
    const objToUpdateTopic = {
      title: { es: "", en: "", ca: "" },
      paragraph: { es: "", en: "", ca: "" }
    };
    const paramsArr = [...state.params, objToUpdateTopic];
    const comp = {
      ...state,
      params: paramsArr
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp
    };

    handlerSetComponents(componentObj, index);
  };

  const removeTopic = indexId => {
    const paramsArr = [...state.params];
    paramsArr.splice(indexId, 1);
    const comp = {
      ...state,
      params: paramsArr
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp
    };

    handlerSetComponents(componentObj, index);
  };

  const getTopic = (topic, i) => {
    const arr = [...state.params];
    arr[i] = topic;
    const comp = {
      ...state,
      params: arr
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp
    };

    handlerSetComponents(componentObj, index);
  };

  return (
    <div className="w-full pt-1 bg-greyFilter pl-10 pb-1 ml-1 pr-2 rounded-r-lg">
      <div className="flex flex-row items-center">
        {languages.map(lang => (
          <div
            key={lang}
            className={`w-full ${
              activeLanguage.toLowerCase() === lang.toLowerCase()
                ? "block"
                : "hidden"
            } ${slider ? "p-1" : "pl-4 pr-1"}`}
          >
            <label
              className="flex flex-col font-americaMonoRegular text-xs uppercase text-black"
              htmlFor="title"
            >
              Title
              <input
                className={`withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ${
                  slider ? "ml-1 p-1  text-sm" : " p-2"
                }`}
                onChange={inputHandler}
                name="title"
                lang={lang}
                type="text"
                value={state.title[lang.toLowerCase()]}
                readOnly={reusableComponent && reusableComponent}
              />
            </label>
          </div>
        ))}
        <label
          className="flex flex-col font-americaMonoRegular text-xs uppercase text-black p-4 pb-0 w-1/8 pt-1 items-center"
          htmlFor="lowerCaseSetUp"
        >
          Case set up
          <div className="mt-1 pb-0 mr-1">
            <label className="switch mb-0 pb-0 h-6">
              <input
                className="switch"
                checked={isLowerCase}
                onChange={() => setLowerCase(!isLowerCase)}
                type="checkbox"
              />
              <div className="switch-slider btn-case" />
            </label>
          </div>
        </label>
        <button
          type="button"
          onClick={addTopic}
          className="font-americaMonoBold text-xs w-40 pl-0 pl-5 py-2 h-10 rounded-full uppercase bg-white flex flex-row self-center items-center mt-1 mr-4"
        >
          Add topic{" "}
          <span className="font-icon icon-add-button text-base font-bold pl-2" />
        </button>
      </div>
      {state.params.map((topic, i) => (
        <div key={i + topic} className="">
          <TopicComponent
            indexId={i}
            topic={topic}
            activeLanguage={activeLanguage}
            languages={languages}
            collapsibleFAQsGetsTopic={getTopic}
            handleRemoveTopic={removeTopic}
            arrLength={state.params.length}
          />
        </div>
      ))}
    </div>
  );
};

CollapsibleFAQs.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool
};
CollapsibleFAQs.defaultProps = {
  reusableComponent: null,
  slider: false
};

export default CollapsibleFAQs;
